// Helpers
import { useMediaQuery } from '@helpers/useMediaQuery'
import { getStyle } from '@helpers/getStyles'

// Styles
import styles from './Text.module.sass'

// Interfaces
import { SpacingData } from '@interfaces/spacing'
import { Colors } from '@interfaces/theme'

interface TextProps {
  tagName: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span'
  variant: string
  children: React.ReactNode
  mobile?: boolean
  transform?: 'uppercase' | 'capitalize' | 'none'
  decoration?: 'underline' | 'lineThrough'
  fontWeight?: 400 | 500 | 600 | 700 | 800 | 900
  color?: Colors
  className?: string
  align?: 'center' | 'left' | 'right'
  spacing?: SpacingData
  fontFamily?: 'inter' | 'lato'
}

interface CustomStyles {
  marginBottom?: string
  fontWeight?: string
}

const Text = ({
  tagName,
  mobile = false,
  transform,
  decoration,
  fontWeight,
  variant,
  color,
  className = '',
  align,
  spacing,
  fontFamily = 'inter',
  children
}: TextProps) => {
  const isDesktop = useMediaQuery(1168)

  const Tag = tagName as keyof JSX.IntrinsicElements

  const customStyles: CustomStyles = {}

  if (spacing) {
    customStyles.marginBottom = getStyle(spacing, isDesktop)
  }

  if (fontWeight) {
    customStyles.fontWeight = fontWeight.toString()
  }

  return (
    <Tag
      style={customStyles}
      className={`
      ${styles[variant]} 
      ${color ? styles[`text-${color}`] : ''} 
      ${align ? styles[`text-${align}`] : ''} 
      ${mobile ? styles['mobile'] : ''} 
      ${transform ? styles[`text-${transform}`] : ''} 
      ${decoration ? styles[`text-${decoration}`] : ''}
      ${styles[fontFamily]} 
      ${className}`}
    >
      {children}
    </Tag>
  )
}

export default Text
